const links = Object.freeze({
  facebook: 'https://www.facebook.com/giglifepro',
  instagram: 'https://www.instagram.com/giglifepro/',
  linkedin: 'https://www.linkedin.com/company/14576445/admin/',
  youtube: 'https://www.youtube.com/@giglifepro',
});

export default links;
